module.exports = __webpack_public_path__ + "img/fondo-banner-principal.343f4dee.svg";